import React from 'react';

const wrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 24,
  height: '100vh',
};

type IProps = {
  children: any;
};
type IState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    console.log('ErrorBoundary', error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={wrapperStyle}>
          SOMETHING WENT WRONG. PLEASE
          <span onClick={window.location.reload}>
            &nbsp;<b>REFRESH</b>&nbsp;
          </span>
          THE PAGE AND TRY AGAIN.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
